<template>
  <div class="bg-white">
    <nav class="sub-menu border-b border-secondary">
      <button
        class="sub-menu-item"
        :class="{ 'router-link-active': $store.state.learningZoneTab === 'general' }"
        @click.prevent="gotoTab('general')">
        Training
      </button>
      <button
        class="sub-menu-item"
        :class="{ 'router-link-active': $store.state.learningZoneTab === 'ca' }"
        @click.prevent="gotoTab('ca')">
        Competency Assessments
      </button>
      <button
        class="sub-menu-item"
        :class="{ 'router-link-active': $store.state.learningZoneTab === 'f2f' }"
        @click.prevent="gotoTab('f2f')">
        Face to Face Courses
      </button>
      <button
        class="sub-menu-item"
        :class="{ 'router-link-active': $store.state.learningZoneTab === 'ec' }"
        @click.prevent="gotoTab('ec')">
        Paper-Based Assessments
      </button>
    </nav>
  </div>
</template>
<script>
export default {
  methods: {
    gotoTab(tab) {
      this.$store.state.learningZoneTab = tab;
      this.$store.commit("closeMobileMenu");
    }
  }
};
</script>

<style lang="postcss" scoped>
.sub-menu {
  @apply bg-secondary bg-opacity-25  px-0 sm:px-12 text-dark-grey text-sm flex flex-row flex-wrap items-center;
}
.sub-menu-item {
  @apply text-xs sm:text-base py-1 sm:py-2 px-4 sm:px-8 
    flex flex-row justify-start items-center flex-none w-full sm:w-auto;
}
.sub-menu-item:hover {
  @apply bg-secondary bg-opacity-75 text-white transition duration-500;
}
.sub-menu-item.router-link-active {
  @apply bg-secondary text-white transition duration-500;
}
</style>
